/**
 * Centralized Mock Application Data
 * Simulates GraphQL responses for different test scenarios
 * Simplified structure with only selfService data
 * Used by StudentDashboard system
 */

// Test scenarios mapped to currentStep values from STEP_DEFINITIONS
export const MOCK_SCENARIOS = {
  // HONORS_INPROGRESS - Application under review
  HONORS_INPROGRESS: {
    selfService: JSON.stringify({
      isOpen: true, // placeholder for global shutoffs to the application
      window: null, // placeholder for possible windows, pre season, in season, post season
      currentStep: "HONORS_INPROGRESS",
      deadline: "April 15, 2026"
    })
  },

  // HONORS_OFFER - Student accepted to Honors
  HONORS_OFFER: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "HONORS_OFFER",
      deadline: "April 15, 2026"
    })
  },

  // HONORS_DENY - Student denied from Honors
  HONORS_DENY: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "HONORS_DENY",
      deadline: null
    })
  },

  // SCHOLARS_PREFERENCES - Student invited to Scholars, needs preferences
  SCHOLARS_PREFERENCES: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "SCHOLARS_PREFERENCES",
      deadline: null
    })
  },

  // SCHOLARS_PREFERENCES_SUBMITTED - Preferences submitted, under review
  SCHOLARS_PREFERENCES_SUBMITTED: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "SCHOLARS_PREFERENCES_SUBMITTED",
      deadline: null
    })
  },

  // HONORS_DECLINED - Student declined their Honors offer
  HONORS_DECLINED: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "HONORS_DECLINED",
      deadline: null
    })
  },

  // HONORS_WITHDRAWN - Application withdrawn
  HONORS_WITHDRAWN: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "HONORS_WITHDRAWN",
      deadline: null
    })
  },

  // =========================================================================
  // Scholars-only (native scholars — no honors application)
  // =========================================================================

  // SCHOLARS_AWAITING - Admin has not yet triggered preferencing
  SCHOLARS_AWAITING: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "SCHOLARS_AWAITING",
      deadline: null
    })
  },

  // SCHOLARS_NATIVE_PREFERENCES - Admin triggered preferencing, student can submit
  SCHOLARS_NATIVE_PREFERENCES: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "SCHOLARS_NATIVE_PREFERENCES",
      deadline: "May 1, 2026"
    })
  },

  // SCHOLARS_NATIVE_SUBMITTED - Native scholars preferences submitted
  SCHOLARS_NATIVE_SUBMITTED: {
    selfService: JSON.stringify({
      isOpen: true,
      window: null,
      currentStep: "SCHOLARS_NATIVE_SUBMITTED",
      deadline: null
    })
  },

  // No Applications - For testing empty state
  NO_APPLICATIONS: {
    selfService: null
  }
};

// Default scenario for testing
export const DEFAULT_SCENARIO = 'HONORS_OFFER';



/**
 * Get mock data for a specific scenario
 * @param {string} scenarioKey - Key from MOCK_SCENARIOS
 * @returns {Object} Mock GraphQL response
 */
export const getMockScenarioData = (scenarioKey = DEFAULT_SCENARIO) => {
  const data = MOCK_SCENARIOS[scenarioKey] || MOCK_SCENARIOS[DEFAULT_SCENARIO];
  return data;
};

/**
 * Get all available scenario keys for testing
 * @returns {Array<string>} Array of scenario keys
 */
export const getAvailableScenarios = () => {
  return Object.keys(MOCK_SCENARIOS);
};